const SECTIONS = {
  new: 'new',
  index: 'index',
  show: 'show',
};

function getSteps(section, intl, user) {
  switch (section) {
    case SECTIONS.new:
      return [
        {
          target: 'body',
          content: intl.formatMessage({ id: 'tooltips.new.intro' }),
          placement: 'center',
          disableBeacon: true,
        },
        {
          target: '#stages',
          content: intl.formatMessage({ id: 'tooltips.new.sections' }),
        },
        {
          target: '#stage-description',
          content: intl.formatMessage({
            id: 'tooltips.new.section_description',
          }),
        },
        // {
        //   target: "#stage-body",
        //   content: intl.formatMessage({
        //     id: "tooltips.new.stage_body"
        //   })
        // },
        {
          target: '#stage-tour-picker',
          content: intl.formatMessage({
            id: 'tooltips.new.stage_tour_picker',
          }),
        },
        {
          target: '#stage-tour',
          content: intl.formatMessage({
            id: 'tooltips.new.stage_tour',
          }),
        },
      ];

    case SECTIONS.index:
      return [
        {
          target: 'body',
          content: intl.formatMessage({ id: 'tooltips.index.intro' }),
          placement: 'center',
          disableBeacon: true,
        },
        {
          target: '#activities-list',
          content: intl.formatMessage({
            id: 'tooltips.index.activities_list',
          }),
        },
        {
          target: '#new-activity',
          content: intl.formatMessage({
            id: 'tooltips.index.new_activity',
          }),
        },
        {
          target: '#vp-selector',
          content: intl.formatMessage({
            id: 'tooltips.index.vp_selector',
          }),
        },
      ];

    case SECTIONS.show:
      return [
        {
          target: 'body',
          content: intl.formatMessage({ id: 'tooltips.show.intro' }),
          placement: 'center',
          disableBeacon: true,
        },
        // {
        //   target: "#activity",
        //   content: intl.formatMessage({ id: "tooltips.show.activity" })
        // },
        // {
        //   target: "#activity-details",
        //   content: intl.formatMessage({ id: "tooltips.show.activity_details" })
        // },
        // {
        //   target: "#activity-vision-details",
        //   content: intl.formatMessage({
        //     id: "tooltips.show.activity_vision_details"
        //   })
        // },
        // {
        //   target: "#activity-connections",
        //   content: intl.formatMessage({
        //     id: "tooltips.show.activity_connections"
        //   })
        // },
        // {
        //   target: "#activity-last-details",
        //   content: intl.formatMessage({
        //     id: "tooltips.show.activity_last_details"
        //   })
        // },
        {
          target: '#activity-buttons',
          content: intl.formatMessage({ id: 'tooltips.show.activity_buttons' }),
        },
      ];

    default:
      return [
        {
          target: 'body',
          content: intl.formatMessage({ id: 'tooltips.intro' }),
          placement: 'center',
          disableBeacon: true,
        },
      ];
  }
}

const TOOLTIPPROPS = {
  getSteps,
  sections: { ...SECTIONS, default: '' },
};

export { TOOLTIPPROPS, SECTIONS };
